export default "__VITE_ASSET__DhEcRW0t__"